import React from 'react';

import { getYear } from 'date-fns';
import { Container } from './styles';

export const Footer: React.FC = () => {
  const year = getYear(new Date());
  return <Container>INTEGRATION CONSULTING © {year}</Container>;
};
